Information about how payment will be made for this advertisement product.
